import React, { useEffect, useState, useRef } from 'react';
import * as echarts from 'echarts';
import { Icon, Modal } from 'tea-component';
import { useMount, useSize } from 'ahooks';
import { getLocale } from 'umi';
import nameMap from '@/pages/dashboard/components/MapEchart/_config/nameMap.json';
import { importJSON } from '@/pages/intelligence/utils/echartsUtils';
import './index.less';
export interface EchartMapProps {
  fullScreenTitle: string;
  //* 0 legend可自定义样式
  className?: string;
  style?: React.CSSProperties;
  /** 地图数据 */
  data: Array<any>;
  // children?: React.ReactElement<HTMLElement>;
  //* 1 双击放大功能？
  doubleClick?: boolean;
  //* 2 单击回调函数
  handleClickFun: (param: any) => void;
  //* 3 是否有全屏按钮
  fullScreen?: boolean;
  //* 4 是否有加减按钮
  zoomButton?: boolean;
  //* 6 tooltip美化及展示回调函数
  tooltipMapFun: (...param: any[]) => any;
  //* 7 视觉映射模块回调函数
  visualMapColorFun: Array<any>;
  //* 8 legend展示
  legendChildren?: React.ReactNode;
  //* 8 全屏的legend展示
  fullScreenLegendChildren?: React.ReactNode;
  //* 9 legend自定义样式- 需要添加前缀包裹
  // prefixCls?: string;
  //* 5 中心位置
  mapHeight?: string | number;
}

export interface EchartMapBarProps extends EchartMapProps {
  /** 是全屏状态还是非全屏状态 */
  showModel: boolean;
  fullLegend?: boolean;
}

export default function EchartMapBar(props: EchartMapBarProps) {
  const {
    data,
    className,
    visualMapColorFun,
    tooltipMapFun,
    handleClickFun,
    legendChildren = null,
    fullScreenLegendChildren = null,
    doubleClick = true,
    zoomButton = true,
    showModel,
    mapHeight,
    fullScreen,
    fullScreenTitle,
    fullLegend,
  } = props;
  const refDom = useRef(null);
  const [options, setOptions] = useState<any>({});
  const [isModel, setisModel] = useState(false);
  const [mapList, setMapList] = useState({});
  const size = useSize(document.querySelector('body'));
  // 地图缩放
  const mapZoom = (type: 'zoomIn' | 'zoomOut') => {
    const opt: any = options;
    if (JSON.stringify(opt) === '{}') {
      return;
    }
    let mapZoomNow = options?.series[0]?.zoom;
    if (type == 'zoomIn' /* && mapZoomNow < 25*/) {
      mapZoomNow = mapZoomNow + 0.5;
    } else if (type == 'zoomOut' /* && mapZoomNow > 1*/) {
      // eslint-disable-next-line no-plusplus
      mapZoomNow--;
      if (mapZoomNow < options?.series[0]?.scaleLimit.min) {
        mapZoomNow = options?.series[0]?.scaleLimit.min;
      }
    }
    opt.series[0].zoom = mapZoomNow;
    setOptions(opt);
    const myChart = echarts.init(refDom!.current!);
    myChart.setOption(opt, true);
  };

  const getMapChart = async () => {
    try {
      const map = await importJSON(
        'https://ogdb-cdn.intlgame.cn/front/static/world.json',
      );
      setMapList(map);
    } catch (e) {
      console.log(e);
    }
  };
  useMount(() => {
    getMapChart();
  });

  useEffect(() => {
    const option = {
      tooltip: {
        trigger: 'item',
        // backgroundColor: '#262832F2',
        formatter: (params: any) => tooltipMapFun(params),
        show: true,
        // extraCssText: 'width:160px;'
        confine: true, // tooltip不被遮挡
        borderWidth: '0',
        backgroundColor: 'rgba(0,0,0,0.75)'
      },
      visualMap: [
        {
          show: false,
          realtime: false,
          calculable: false,
          pieces: visualMapColorFun,
        },
      ],
      series: [
        {
          // name: '香港18区人口密度',
          type: 'map',
          map: 'world',
          // center: [44.114129, 17.550339],//当前视角的中心点
          zoom: 1.05, // 当前视角的缩放比例
          roam: true, // 是否开启平游或缩放
          scaleLimit: {
            // 滚轮缩放的极限控制
            min: 0.8,
            // max: 6
          },
          itemStyle: {
            normal: {
              borderColor: 'rgba(190, 190, 190,0.5)',
              borderWidth: 1,
              areaColor: '#f2f2f2',
              // areaColor: '#fff',
            },
            emphasis: {
              label: { show: true },
              itemStyle: {
                borderColor: '#000',
                borderWidth: '2',
                borderType: 'solid',
                shadowColor: 'rgba(0, 0, 0, 0.5)',
                shadowBlur: 10,
              },
            },
          },
          label: {
            show: false,
            emphasis: {
              // 对应的鼠标悬浮效果
              textStyle: { color: '#000' },
            },
          },
          data,
          nameMap: getLocale() === 'zh-CN' ? nameMap : null,
        },
      ],
    };
    const myChart = echarts.init(refDom!.current!);
    let clickType: boolean | null = null;
    // console.log('世界地图（基础）',option)
    setOptions(option);
    myChart.showLoading();
    // console.log(mapList);
    echarts.registerMap('world', mapList);
    myChart.setOption(option, true);
    myChart.getZr().on('mousemove', (param) => {
      if (param.target) {
        // 若鼠标滑过区域位置在当前图表范围内 鼠标设置为小手
        myChart.getZr().setCursorStyle('pointer');
      } else {
        myChart.getZr().setCursorStyle('move');
      }
    });
    myChart.on('georoam', () => {});
    myChart.on('click', (params) => {
      clickType = false;
      setTimeout(() => {
        // 此处为单击事件要执行的代码
        if (clickType === false) {
          handleClickFun(params);
        }
      }, 550);
    });
    myChart.on('dblclick', () => {
      clickType = true;
    });
    myChart.resize();
    myChart.hideLoading();
  }, [
    data,
    handleClickFun,
    tooltipMapFun,
    visualMapColorFun,
    mapList,
    size,
    getLocale,
  ]);

  return (
    <div className="eacherMapCpt">
      <div className={`eacherMapCpt ${className}${showModel ? '-Model' : ''}`}>
        <div
          className="eacherMapCpt-Map"
          onDoubleClick={() => {
            if (doubleClick) {
              mapZoom('zoomIn');
            }
          }}
          ref={refDom}
          style={{
            cursor: 'move',
            height: mapHeight || 'auto',
            overflow: 'hidden',
          }}
        />
        {fullScreen && (
          <div
            className="eacherMapCpt-ControlItem eacherMapCpt-fullScreen"
            onClick={() => {
              setisModel(true);
            }}
          >
            <Icon type="fullscreen" />
          </div>
        )}
        {
          /* map右下角放大/缩小控制按钮*/
          zoomButton && (
            <div
              className={`eacherMapCpt-MapControl${showModel ? '-Model' : ''}`}
            >
              <div
                className="eacherMapCpt-ControlItem"
                onClick={() => {
                  mapZoom('zoomIn');
                }}
              >
                <Icon type="plus" />
              </div>
              <div
                className="eacherMapCpt-ControlItem eacherMapCpt-ControlItem2"
                onClick={() => {
                  mapZoom('zoomOut');
                }}
              >
                <Icon type="minus" />
              </div>
            </div>
          )
        }

        {fullLegend && fullScreenLegendChildren
          ? fullScreenLegendChildren
          : legendChildren}
      </div>

      <Modal
        className="marketsize-echartmap-modal"
        visible={isModel}
        size={1000}
        caption={fullScreenTitle}
        onClose={() => {
          setisModel(false);
        }}
      >
        <Modal.Body>
          <EchartMapBar
            {...props}
            mapHeight={(size && size?.height < 800) ? (size?.height * 0.9 - 148) : (800 - 148)}
            showModel={false}
            fullScreen={false}
            fullLegend={true}
          />
        </Modal.Body>
      </Modal>
    </div>
  );
}
